import { createClient, SupabaseClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL ?? '';
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY ?? '';

if (!url || !anonKey) {
  // Surface this loudly in dev — without these the app cannot authenticate.
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY not set; auth will fail.',
  );
}

// createClient throws on an empty URL, which would crash the whole app in
// local dev; fall back to a placeholder so the warning above is the only symptom.
export const supabase: SupabaseClient = createClient(url || 'http://localhost:54321', anonKey || 'missing-anon-key', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
